
frequency_lists = 
  passwords: "123456,password,12345678,qwerty,123456789,12345,1234,111111,1234567,dragon,123123,baseball,abc123".split(",")
  english_wikipedia: "the,of".split(",")
  female_names: "mary,patricia".split(",")
  surnames: "smith,johnson".split(",")
  us_tv_and_film: "you,i".split(",")
  male_names: "james,john".split(",")
module.exports = frequency_lists
